export default __webpack_public_path__ + "static/media/tiger.1fce1898.jpg";